module.exports = __webpack_public_path__ + "img/a3.11439ad2.png";